export default __webpack_public_path__ + "static/media/demonlogistbg.9bdc4fa8.jpg";